var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotoken(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 140,
    viewBox: "0 0 176 140",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M83.7902 2.56927C85.7574 -0.500404 90.2426 -0.500412 92.2098 2.56926L174.866 131.552C176.998 134.88 174.609 139.25 170.656 139.25H5.34402C1.39143 139.25 -0.998373 134.88 1.13424 131.552L83.7902 2.56927Z",
    fill: "#F2C345"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M93.416 57.0156L92.1416 101.796H82.3418L81.0674 57.0156H93.416ZM80.7158 115.595C80.7158 113.866 81.3018 112.416 82.4736 111.244C83.6748 110.043 85.2861 109.442 87.3076 109.442C89.3291 109.442 90.9258 110.043 92.0977 111.244C93.2988 112.416 93.8994 113.866 93.8994 115.595C93.8994 117.294 93.2988 118.729 92.0977 119.901C90.9258 121.073 89.3291 121.659 87.3076 121.659C85.2861 121.659 83.6748 121.073 82.4736 119.901C81.3018 118.729 80.7158 117.294 80.7158 115.595Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotoken);
export default __webpack_public_path__ + "static/media/notoken.2046644b.svg";
export { ForwardRef as ReactComponent };